function dropdownMenu() {
  const dropdownButton = document.getElementById('dropdown-button')
  const dropdownRegion = document.getElementById('dropdown-region')
  // Button inside the region that can also close the menu, for keyboard navigation
  const dropdownRegionButton = document.getElementById('dropdown-region-close')

  function showMenu() {
    dropdownButton.classList.add('active')
    dropdownButton.setAttribute('aria-expanded', true)

    dropdownRegion.classList.add('active')
    dropdownRegion.setAttribute('aria-hidden', false)
  }

  function hideMenu() {
    dropdownButton.classList.remove('active')
    dropdownButton.setAttribute('aria-expanded', false)

    dropdownRegion.classList.remove('active')
    dropdownRegion.setAttribute('aria-hidden', true)
  }

  // Add event listeners
  dropdownButton.addEventListener('click', function() {
    if (this.classList.contains('active')) {
      hideMenu()
    } else {
      showMenu()
    }
  })

  dropdownRegionButton.addEventListener('click', function() {
    hideMenu()
  })

  document.addEventListener("click", function (event) {
    if (dropdownButton.classList.contains("active")) {
      if (
        !dropdownButton.contains(event.target) &&
        !dropdownRegion.contains(event.target)
      ) {
        hideMenu();
      }
    }
  });

  const dropdownConfButton = document.getElementById('conference-dropdown-menu--button');
  const dropdownConfRegion = document.getElementById('conference-dropdown-menu--region');

  // Add event listeners
  dropdownConfButton.addEventListener('mouseenter', function() {
    dropdownConfRegion.style.display = 'block';
  });

  // Add event listeners
  dropdownConfRegion.addEventListener('mouseleave', function() {
    dropdownConfRegion.style.display = 'none';
  });

  document.onkeydown = function(evt) {
    evt = evt || window.event;
    var isEscape = false;
    if ("key" in evt) {
      isEscape = (evt.key === "Escape" || evt.key === "Esc");
    } else {
      isEscape = (evt.keyCode === 27);
    }
    if (isEscape) {
      dropdownConfRegion.style.display = 'none';
      hideMenu()
    }
};

};


window.addEventListener('load', function(){
  dropdownMenu();
});
